import { useState, useEffect, Fragment } from 'react';
import LoadingComponent from './../../widgets/LoadingComponent';
import { Breadcrumb } from 'react-bootstrap';
import {
    FaSearch,
    FaCheckCircle,
    FaRegTimesCircle,
    FaPlus,
    FaBackspace,
    FaMinus,
    FaInbox,
    FaDownload,
    FaFilePdf
} from 'react-icons/fa';
import { NumericFormat } from 'react-number-format';
import Button from 'react-bootstrap/Button';
import AsyncSelect from 'react-select/async';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { getData, postData } from '../../api/ApiRest';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepButton from '@mui/material/StepButton';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { useSelector } from 'react-redux';
import { formatDateddMMMyyyy } from '../../widgets/DateTime';
import { useNavigate } from 'react-router-dom';
import XLSX from 'xlsx-js-style';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFDownloadLink
} from "@react-pdf/renderer";
import { usePermission } from '../../helper/authHelper';

const styles = StyleSheet.create({
    page: { padding: 20 },
    table: { marginTop: 10 },
    row: { flexDirection: "row" },

    // Celda base compartida
    cell: {
        border: "1px solid black",
        padding: 5,
        fontSize: 8,
        flexWrap: 'wrap',       // permite que el texto haga salto de línea
    },

    // Header centrado
    header: {
        fontWeight: "bold",
        textAlign: 'center',
        backgroundColor: '#e0e0e0',
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 20,
        right: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopWidth: 1,
        borderTopColor: '#cccccc',
        paddingTop: 6,
    },
    footerText: {
        fontSize: 8,
        color: '#666666',
    },
    footerPage: {
        fontSize: 8,
        color: '#666666',
    },

    // Anchos por columna (flexBasis define el ancho, flexShrink:0 evita que se comprima)
    col_nit: { flexBasis: '12%', flexShrink: 0 },
    col_tipo: { flexBasis: '18%', flexShrink: 0 },
    col_doc: { flexBasis: '10%', flexShrink: 0 },
    col_fecha: { flexBasis: '14%', flexShrink: 0 },
    col_emisor: { flexBasis: '22%', flexShrink: 0 },
    col_total: { flexBasis: '12%', flexShrink: 0, textAlign: 'right' },
    col_estado: { flexBasis: '12%', flexShrink: 0, textAlign: 'center' },
    col_etapa: { flexBasis: '16%', flexShrink: 0, textAlign: 'center' },
    col_nit_emisor: { flexBasis: '12%', flexShrink: 0, textAlign: 'center' }
});

const Pasos = [{
    label: 'Acuse',
    paso: 1,
    accion: '',
    EventId: 1
},
{
    label: 'Recibido',
    paso: 2,
    accion: 'Confimar recibido de bien',
    EventId: 3
},
{
    label: 'Aceptado',
    paso: 3,
    accion: 'Aceptacion de factura',
    EventId: 4
}];



function RadianIndex() {
    const [loading, setLoading] = useState(false);
    const [rechazoDocumento, setRechazoDocumento] = useState({ Razonid: '-1', DocumentoId: '' })
    const [dataBuscar, setDataBuscar] = useState({
        Prefijo: '',
        Numero: '',
        ClienteNit: '',
        EmisorId: '',
        TipoDocumentoid: 'null',
        EstadoDocumento: '1',
        Desde: moment(new Date(new Date(new Date().setHours(1)).setMinutes(0, 0))).format("yyyy-MM-DDTHH:mm"),
        Hasta: moment(new Date(new Date(new Date().setHours(23)).setMinutes(59, 0))).format("yyyy-MM-DDTHH:mm"),
    });
    const [documentsRadian, setDocumentsRadian] = useState([]);
    const [adminTae, SetAdminTae] = useState(false);
    const [modalNuevo, setModalNuevo] = useState(false);
    const [modalRechazo, setModalRechazo] = useState(false);

    const [registrosCargados, setRegistrosCargados] = useState([]);
    const [eventos, setEventos] = useState(null);

    const [modalEventos, setModalEventos] = useState({
        ModalVisible: false, Titulo: ''
    });

    const infoUser = useSelector((state) => state.auth.tokenSesion);
    const infoAdmin = useSelector((state) => state.auth.AdminTae);
    const infoUrl = useSelector((state) => state.auth.AmbienteTae_Url);

    const { GestionCorreoRadian } = usePermission([
        "GestionCorreoRadian"
    ]);

    const navigate = useNavigate();

    useEffect(() => {
        SetAdminTae(infoAdmin === 'true');
    }, [])

    const uploadFileRadian = async (files = []) => {
        if (files != null) {
            setLoading(true);

            const formData = new FormData();

            files.forEach(file => {
                formData.append("files", file);
            })

            let UrlBase = infoUrl +
                'api/Cliente/Radian/UpdateRadian_V2';

            ///Pendiente asignar token aqui
            const token = infoUser;//localStorage.getItem('tokenSesion');

            await fetch(UrlBase, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json'
                },
                body: formData
            }).then(response => response.json()).then(response => {
                setRegistrosCargados(response.list);

                // if (response.status === true) {
                //     alert('Documento cargado con exito');
                // }
                // else {
                //     alert(response.msj);
                // }

                setLoading(false);
                console.log(response);
            }, error => {
                alert('algo salio mal');
                setLoading(false);
                console.log(error);
            })

        }
    }

    // const uploadFileRadian = (File) => {
    //     if (File != null) {
    //         setLoading(true);

    //         const formData = new FormData();
    //         formData.append("file", File);

    //         let UrlBase = localStorage.getItem('AmbienteTae_Url') +
    //             'api/Cliente/Radian/UpdateRadian';

    //         ///Pendiente asignar token aqui
    //         const token = infoUser;//localStorage.getItem('tokenSesion');

    //         fetch(UrlBase, {
    //             method: 'POST',
    //             headers: {
    //                 'Authorization': 'Bearer ' + token,
    //                 'Accept': 'application/json'
    //             },
    //             body: formData
    //         }).then(response => response.json()).then(response => {

    //             if (response.status === true) {
    //                 alert('Documento cargado con exito');
    //             }
    //             else {
    //                 alert(response.msj);
    //             }

    //             setLoading(false);
    //             console.log(response);
    //         }, error => {
    //             alert('algo salio mal');
    //             setLoading(false);
    //             console.log(error);
    //         })

    //     }
    // }



    const buscarDocumentos = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Cliente/Radian/RadianGet', {
            Prefijo: dataBuscar.Prefijo,
            Number: dataBuscar.Numero,
            CompanyId_Emisior: dataBuscar.EmisorId,
            ClienteNit: dataBuscar.ClienteNit,
            Enviroment: '',
            FechaDesde: dataBuscar.Desde,
            FechaHasta: dataBuscar.Hasta,
            TipoDocumentoId: dataBuscar.TipoDocumentoid,
            EstadoDocumento: dataBuscar.EstadoDocumento
        }, true).then(response => {
            console.log(response);
            if (response.status === true) {
                setDocumentsRadian(response.documentsRadian);

                console.log(response.documentsRadian);
            }
            // setDocuments(response.documents);
            setLoading(false)
        }, error => {
            alert('algo salio mal con la busqueda');
            console.log(error);
            setLoading(false)
        })

    }



    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                console.log(response);
                return response.companies;
            }, error => {
                return [];
            })
    }




    const actualizarEstado = (id, EstadoNuevo) => {
        setLoading(true);

        postData('api/Cliente/Radian/UpdateRadianEstado', {
            id: id,
            EventId: EstadoNuevo
        }, {}).then(response => {
            console.log(response);
            if (response.status === true) {
                alert('Documento Actualizado con exito');
                setLoading(false);
                // buscarDocumentos();
            } else {
                alert(response.msj);
                console.log(response);
                setLoading(false);
            }

        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })
    }


    const rechazoEstado = (id, RechazoId) => {
        if (RechazoId === '-1') {
            alert('Por favor selecciona un motivo de rechazo');
            return;
        }

        setLoading(true);

        postData('api/Cliente/Radian/RechazarDocumento', {
            id: id,
            Type_RejectId: RechazoId
        }, {}).then(response => {
            console.log(response);
            if (response.status === true) {
                alert('Documento Actualizado con exito');
                setModalRechazo(false);
                setLoading(false);
                // buscarDocumentos();
            } else {
                alert(response.msj);
                console.log(response);
                setLoading(false);
            }

        }, error => {
            setLoading(false);
            alert('Algo salio mal, por favor verifica');
            console.log(error);
        })
    }




    const actEstadoDocumentoConfirm = (id, EstadoNuevo, Titulo, Mensaje) => {

        if (String(EstadoNuevo) === '4') {
            actEstadoDocumentoRecibido(id);
        } else {

            const options = {
                title: Titulo,
                message: Mensaje,
                buttons: [
                    {
                        label: 'Si',
                        onClick: () => {
                            actualizarEstado(id, EstadoNuevo)
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => { }
                    }
                ],
                closeOnEscape: true,
                closeOnClickOutside: true,
                keyCodeForClose: [8, 32],
                willUnmount: () => { },
                afterClose: () => { },
                onClickOutside: () => { },
                onKeypress: () => { },
                onKeypressEscape: () => { },
                overlayClassName: "overlay-custom-class-name"
            };

            confirmAlert(options);

        }

    }



    const actEstadoDocumentoRecibido = (id) => {
        const options = {
            title: 'Tipo de aceptación',
            message: 'Por favor especifica el tipo de aceptación',
            buttons: [
                {
                    label: 'Expresa',
                    onClick: () => actualizarEstado(id, '4')
                },
                {
                    label: 'Tácita',
                    onClick: () => actualizarEstado(id, '4')
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypress: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "overlay2-custom-class-name"
        };

        confirmAlert(options);
    }



    const getLogsDocument = (id) => {
        setLoading(true);

        getData('api/Cliente/Radian/GetLogEventsDocument', {
            id
        }).then(response => {
            setEventos(response.resultado);

            setLoading(false);
        }, error => {
            setLoading(false);
            alert('Algo salio mal');
            console.log(error);
        })
    }


    const getButtonStep = (item, label, stepProps, labelProps, paso) => {
        const StepStatus = getStatusDocument(item);

        if (StepStatus === 0 && paso.paso === 1) {
            ///Cuando la factura no tiene acuse, procede a recibir la venta

            return <Step key={label} {...stepProps} >
                <StepButton title={paso.accion}
                    onClick={() => actEstadoDocumentoConfirm(item.id, paso.EventId, 'Actualizar Estado', 'Esta seguro que desea confirmar el acuse de recibido')}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                </StepButton>
            </Step>
        }
        else if (StepStatus === 1 && paso.paso === 2) {
            ///Cuando esta la factura tiene acuse, pero no se tiene el recibido del bien

            return <Step key={label} {...stepProps} >
                <StepButton title={paso.accion}
                    onClick={() => actEstadoDocumentoConfirm(item.id, paso.EventId, 'Actualizar Estado', 'Esta seguro que desea confirmar la recepcion de los bienes')}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                </StepButton>
            </Step>
        }
        else if (StepStatus === 2 && paso.paso === 3) {
            ///Cuando esta la factura tiene recibido del bien, pero no aun la aceptacion final

            return <Step key={label} {...stepProps} >
                <StepButton title={paso.accion}
                    onClick={() => actEstadoDocumentoConfirm(item.id, paso.EventId, 'Actualizar Estado', 'Esta seguro que desea confirmar la aceptacion')}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                </StepButton>
            </Step>
        }
        else {
            return <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
        }

    }


    const btnRechazo = (item) => {
        if (item.aceptacion === 0 && item.rechazo !== 1) {
            return <button
                onClick={() => {
                    setModalRechazo(true);
                    setRechazoDocumento({
                        ...rechazoDocumento,
                        DocumentoId: item.id
                    });
                }}
                className='btn btn-sm btn-danger' title='Rechazar'>
                <FaBackspace size={'1rem'} />
            </button>
        }
    }


    const getStatusDocument = (item) => {
        //acusaco_Recibido
        //recepcion_Bienes
        //aceptacion
        //rechazo


        ///Se revisa siempre desde el estado final hasta el inicial
        if (item.aceptacion === 1)
            return 3;
        else if (item.recepcion_Bienes === 1)
            return 2;
        else if (item.acusaco_Recibido === 1)
            return 1;
        else
            return 0;

    }

    const handleCorreos = () => {
        navigate('/Cliente/RadianCorreoIndex');
    }

    const descargarExcel = (data) => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Estilo para el header (primera fila)
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
            if (!worksheet[cellRef]) continue;

            worksheet[cellRef].s = {
                fill: { fgColor: { rgb: '2F75B6' } },   // Fondo azul
                font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 12 },
                alignment: { horizontal: 'center' },
                border: {
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                },
            };
        }

        // Ajuste de columnas
        worksheet['!cols'] = Object.keys(data[0]).map((key) => ({
            wch: Math.max(key.length, ...data.map((r) => String(r[key] ?? '').length)) + 2,
        }));

        worksheet['!autofilter'] = { ref: worksheet['!ref'] };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
        XLSX.writeFile(workbook, 'reporte.xlsx');
    }

    const columnasMap = {
        empresaNit: "Nit adquiriente",
        typeDocument: "Tipo documento",
        numero: "Documento",
        fechaEmision: "Fecha emisión",
        clienteNit: "Nit emisor",
        cliente: "Nombre emisor",
        total: "Total",
        state_document_id: "Estado",
        etapa: "Etapa"
    };

    const columnasEstilos = {
        empresaNit: styles.col_nit,
        typeDocument: styles.col_tipo,
        numero: styles.col_doc,
        fechaEmision: styles.col_fecha,
        clienteNit: styles.col_nit_emisor,
        cliente: styles.col_emisor,
        total: styles.col_total,
        state_document_id: styles.col_estado,
        etapa: styles.col_etapa
    };

    const columnasVisibles = [
        "empresaNit",
        "typeDocument",
        "numero",
        "fechaEmision",
        "clienteNit",
        "cliente",
        "total",
        "state_document_id",
        "etapa"
    ];

    const formatearValorCelda = (col, valor, item) => {
        if (col === 'fechaEmision') {
            return moment(valor).format('DD-MM-YYYY');
        }
        if (col === 'state_document_id') {
            return String(valor) === '1' ? 'Correcto' : 'Incorrecto';
        }
        if (col === 'etapa') {
            return formatearEtapa(item);
        }
        if (col === 'total') {
            return new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(valor ?? 0);
        }
        return String(valor ?? '');
    };

    const formatearEtapa = (item) => {
        if (item.rechazo === 1) return 'Rechazado';
        const status = getStatusDocument(item);
        switch (status) {
            case 0: return 'Sin acuse';
            case 1: return 'Acuse';
            case 2: return 'Recibido';
            case 3: return 'Aceptado';
            default: return '-';
        }
    };

    const MiPdf = ({ datos, columnas }) => {
        const fechaGeneracion = moment().format('DD-MM-YYYY / hh:mm:ss a');

        return (
            <Document>
                <Page size="A4" orientation="landscape" style={styles.page}>
                    <Text style={{ fontSize: 12, marginBottom: 8, fontWeight: 'bold' }}>
                        Reporte RADIAN
                    </Text>
                    <View style={styles.table}>

                        {/* Encabezados */}
                        <View style={styles.row}>
                            {columnas.map(col => (
                                <Text
                                    style={[styles.cell, styles.header, columnasEstilos[col]]}
                                    key={col}
                                >
                                    {columnasMap[col]}
                                </Text>
                            ))}
                        </View>

                        {/* Filas de datos */}
                        {datos.map((item, index) => (
                            <View
                                style={[styles.row, index % 2 === 0 ? { backgroundColor: '#f9f9f9' } : {}]}
                                key={index}
                            >
                                {columnas.map(col => {
                                    const estiloExtra =
                                        col === 'estado'
                                            ? { color: item[col] === true ? 'green' : 'red', textAlign: 'center' }
                                            : col === 'etapa'
                                                ? {
                                                    color: item.rechazo === 1 ? 'red'
                                                        : getStatusDocument(item) === 3 ? 'green'
                                                            : '#cc8800'
                                                }   // naranja para etapas intermedias
                                                : {};

                                    return (
                                        <Text
                                            style={[styles.cell, columnasEstilos[col], estiloExtra]}
                                            key={col}
                                        >
                                            {formatearValorCelda(col, item[col], item)}
                                        </Text>
                                    );
                                })}
                            </View>
                        ))}

                    </View>

                    <View style={styles.footer} fixed>
                        <Text style={styles.footerText}>
                            Generado por TAE-COL SAS — {fechaGeneracion}
                        </Text>
                        <Text
                            style={styles.footerPage}
                            render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
                        />
                    </View>
                </Page>
            </Document>
        );
    };

    const ExportarPDF = () => (
        <PDFDownloadLink
            document={
                <MiPdf
                    datos={documentsRadian}
                    columnas={columnasVisibles} />
            }
            fileName='reporte.pdf'
            style={{ textDecoration: 'none' }}
            title='Descargar a PDF'
        >
            {({ loading }) => (
                <Button size='sm' variant='dark' disabled={loading} title='Descargar a PDF'>
                    <FaFilePdf size={'0.8rem'} />
                </Button>
            )}
        </PDFDownloadLink>
    );

    return <div className='BodyComponent'>
        <Breadcrumb>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Cliente</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Eventos RADIAN</Breadcrumb.Item>
        </Breadcrumb>

        <div className="d-flex gap-1">
            <Button type='button' variant='success' title='Nuevo RADIAN' size='sm'
                onClick={() => setModalNuevo(true)}>
                <FaPlus size={'0.8rem'} />
            </Button>
            {adminTae !== true && GestionCorreoRadian ?
                <Button title='Procesar correos' style={{ fontSize: 12 }} size='sm' variant='primary' type='button' onClick={() => handleCorreos()}>
                    <FaInbox size={'0.8rem'} />
                </Button>
                : null}
            <Button size='sm' type='button' style={{ fontSize: 12 }} variant='warning' onClick={() => descargarExcel(documentsRadian)} title='Descargar a Excel'>
                <FaDownload size={'0.8rem'} />
            </Button>
            <ExportarPDF />
        </div>

        <br />

        <Form onSubmit={buscarDocumentos}>

            <div className='row'>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="EmisionDesde"
                        label="Emision Desde"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="datetime-local"
                            autoComplete='off'
                            required={true}
                            placeholder="Emision Desde"
                            value={dataBuscar.Desde}
                            onChange={value => {
                                // console.log(value.target.value)
                                setDataBuscar({
                                    ...dataBuscar,
                                    Desde: value.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="EmisionHasta"
                        label="Emision Hasta"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="datetime-local"
                            autoComplete='off'
                            required={true}
                            placeholder="Emision Hasta"
                            value={dataBuscar.Hasta}
                            onChange={value => {
                                setDataBuscar({ ...dataBuscar, Hasta: value.target.value })
                            }}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-6'>
                    <FloatingLabel
                        controlId="TipoDocumento"
                        label="Tipo Documento"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.TipoDocumentoid}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    TipoDocumentoid: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            <option value="null">TODOS</option>
                            <option value="1">Factura de Venta Nacional</option>
                            <option value="2">Factura de Exportación</option>
                            <option value="3">Factura de Contingencia</option>
                            <option value="4">Nota Crédito</option>
                            <option value="5">Nota Débito</option>
                            <option value="11">Documento Soporte Electrónico</option>
                            <option value="13">Nota de Ajuste al Documento Soporte Electrónico</option>
                            <option value="15">Documento equivalente P.O.S.</option>
                            <option value="25">Nota de Ajuste de tipo debito al Documento Equivalente</option>
                            <option value="26">Nota de Ajuste de tipo crédito al Documento Equivalente</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>


                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="EstadoDocumento"
                        label="Estado Documento"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.EstadoDocumento}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    EstadoDocumento: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            <option value="-9">Todos</option>
                            <option value="1">Aceptado</option>
                            <option value="0">Rechazado</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Prefijo"
                        label="Prefijo"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="Prefijo"
                            value={dataBuscar.Prefijo}
                            onChange={value => setDataBuscar({ ...dataBuscar, Prefijo: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Consecutivo"
                        label="Consecutivo"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="number"
                            autoComplete='off'
                            placeholder="Consecutivo"
                            value={dataBuscar.Numero}
                            onChange={value => setDataBuscar({ ...dataBuscar, Numero: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="ClienteNit"
                        label="Cliente Identificación"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="number"
                            autoComplete='off'
                            placeholder="Cliente Identificación"
                            value={dataBuscar.ClienteNit}
                            onChange={value => setDataBuscar({ ...dataBuscar, ClienteNit: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                {adminTae === true ?
                    <>
                        <div className='col-md-5'>
                            <label>Empresa Emisora</label>
                            <AsyncSelect cacheOptions defaultOptions
                                menuPosition='fixed'
                                noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                                placeholder="Empresa Emisora"
                                isClearable={true}
                                loadOptions={companieSearchSelect2}
                                onChange={value => {

                                    if (value === null)
                                        setDataBuscar({ ...dataBuscar, EmisorId: null })
                                    else
                                        setDataBuscar({ ...dataBuscar, EmisorId: value.value })
                                }}
                            />

                        </div>

                    </>
                    :
                    null
                }


                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size='sm'>
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>

        </Form>



        {<LoadingComponent Loading={loading} />}

        <hr />

        <div className='table-responsive mt-3'>
            <table className='table table-bordered  table-hover'>
                <thead>
                    <tr className='table-info'>
                        {adminTae === true ?
                            <th style={{ fontSize: 12 }}>
                                Emisor Nit
                            </th>
                            : null}
                        <th style={{ fontSize: 12 }}>
                            Tipo Documento
                        </th>
                        <th style={{ fontSize: 12 }}>
                            Documento
                        </th>
                        <th style={{ fontSize: 12 }}>
                            Fecha Emisión
                        </th>
                        <th style={{ fontSize: 12 }}>
                            Cliente
                        </th>
                        <th style={{ fontSize: 12 }}>
                            Total
                        </th>

                        <th style={{ fontSize: 12 }}>
                            Estado
                        </th>
                        <th style={{ fontSize: 12 }}>
                            Etapa
                        </th>
                        <th></th>
                        <th></th>
                        {/* <th style={{ fontSize: 12 }}>
                            <button className='btn btn-sm btn-dark' type='button' title='Seleccionar todo' onClick={() => seleccionaRegistros(true)} onDoubleClick={() => seleccionaRegistros(false)}>
                                <FaCheckCircle size={'1rem'} />
                            </button>
                        </th> */}
                    </tr>
                </thead>
                <tbody>
                    {documentsRadian.map((item, key) => (
                        <tr key={key}>
                            {adminTae === true ?
                                <td className='text-center' style={{ fontSize: 12 }}>
                                    {item.empresaNit}
                                </td>
                                : null}
                            <td style={{ fontSize: 12 }}>
                                {item.typeDocument}
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {item.prefijo + ' - ' + item.numero}
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {moment(item.fechaEmision).format('D-MM-yyyy / hh:mm:ss a')}
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {item.clienteNit + ' - ' + item.cliente}
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                <NumericFormat displayType='text'
                                    thousandSeparator=','
                                    value={item.total} />
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {item.state_document_id === 1 ?
                                    <FaCheckCircle size={'1rem'} color='green' />
                                    :
                                    <FaRegTimesCircle size={'1rem'} color='red' />
                                }
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {item.rechazo === 1 ?
                                    <b className='text-danger'>Rechazado</b>
                                    :
                                    <Stepper activeStep={getStatusDocument(item)} alternativeLabel>
                                        {Pasos.map((paso, index) => {
                                            const stepProps = {};
                                            const labelProps = {};

                                            return getButtonStep(item, paso.label, stepProps, labelProps, paso)

                                        })}
                                    </Stepper>
                                }

                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                {btnRechazo(item)}
                            </td>
                            <td className='text-center' style={{ fontSize: 12 }}>
                                <button className='btn btn-sm btn-primary' type='button' title='Buscar eventos' onClick={() => {
                                    getLogsDocument(item.id);

                                    setModalEventos({
                                        ModalVisible: true, Titulo: 'Visualizar eventos'
                                    });
                                }}>
                                    <FaSearch size={'1rem'} />
                                </button>
                            </td>

                            {/* <td className='text-center' style={{ fontSize: 12 }}>
                                <Form.Check checked={item.selected}
                                    onChange={event =>
                                        setDocumentsRadian(
                                            documentsRadian.map(p => p.id === item.id ?
                                                { ...p, selected: !item.selected } : p
                                            )
                                        )
                                    } />
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>


        <Modal
            size='xl'
            show={modalNuevo}
            onShow={() => { }}
            onHide={() => {
                setModalNuevo(false);
                setRegistrosCargados([]);
            }}>
            <Modal.Header closeButton>
                <Modal.Title>CARGAR DOCUMENTO A RADIAN</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {<LoadingComponent Loading={loading} />}

                <div className='row'>
                    <div className='col-md-12'>
                        <label className="form-label">Cargue de XML</label>
                        <input className="form-control" type="file" accept='application/xml'
                            onChange={file => {
                                uploadFileRadian(Array.from(file.target.files))
                            }}
                            multiple
                            id="formFile"></input>
                        {/* <input className="form-control" type="file" accept='application/xml'
                    onChange={file => {
                        uploadFileRadian(file.target.files[0])
                    }}
                    id="formFile"></input> */}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='table-responsive mt-3'>
                            <table className='table table-bordered table-hover'>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Documento</th>
                                        <th>Fecha</th>
                                        <th>Estado</th>
                                        <th>Mensaje</th>
                                        {/* <th style={{ fontSize: 12 }}>
                                            <button className='btn btn-sm btn-dark' type='button' title='Seleccionar todo' onClick={() => seleccionaRegistros_Nuevos(true)} onDoubleClick={() => seleccionaRegistros_Nuevos(false)}>
                                                <FaCheckCircle size={'1rem'} />
                                            </button>
                                            <button className='btn btn-sm btn-warning' type='button' title='Cambiar estado masivo' onClick={() => cambiarEstadoMasivoNuevo()}>
                                                <FaArrowUp size={'1rem'} />
                                            </button>
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {registrosCargados.map((item, index) => (
                                        <tr key={index}>
                                            <td className='text-center'>
                                                {index + 1}
                                            </td>
                                            <td className='text-center'>
                                                {item.response.invoice_number}
                                            </td>
                                            <td className='text-center'>
                                                {formatDateddMMMyyyy(item.response.invoice_date)}
                                            </td>
                                            <td className='text-center'>
                                                {item.response.success ? <FaCheckCircle size={'1rem'} color='green' /> : <FaMinus size={'1rem'} color='red' />}
                                            </td>
                                            <td className='text-center'>
                                                {item.response.message}
                                            </td>
                                            {/* {item.response.success ?
                                                <td className='text-center' style={{ fontSize: 12 }}>
                                                    <Form.Check checked={item.selected}
                                                        onChange={event =>
                                                            setRegistrosCargados(
                                                                registrosCargados.map(p => p.response.invoice_number === item.response.invoice_number ?
                                                                    { ...p, selected: !item.selected } : p
                                                                )
                                                            )
                                                        } />
                                                </td> : null} */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </Modal.Body>
        </Modal>

        <Modal
            size='xl'
            show={modalEventos.ModalVisible}
            onShow={() => { }}
            onHide={() => {
                setEventos(null);
                setModalEventos({
                    ModalVisible: false, Titulo: ''
                });
            }}>
            <Modal.Header closeButton>
                <Modal.Title>{modalEventos.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {<LoadingComponent Loading={loading} />}

                <div className='row'>
                    <pre>{eventos}</pre>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            size='xl'
            show={modalRechazo}
            onShow={() => { }}
            onHide={() => setModalRechazo(false)}>
            <Modal.Header closeButton>
                <Modal.Title>RECHAZAR DOCUMENTO</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {<LoadingComponent Loading={loading} />}


                <div className='row'>

                    <div className='col-md-8'>
                        <FloatingLabel
                            controlId="RechazoSelect"
                            label="Motivo de Rechazo"
                            className="mb-3"
                        >
                            <Form.Select
                                size='sm'
                                value={rechazoDocumento.Razonid}
                                onChange={event => {
                                    setRechazoDocumento({
                                        ...rechazoDocumento,
                                        Razonid: event.target.value
                                    })
                                }}
                            >
                                <option value="-1">Seleccione</option>
                                <option value="1">Documento con inconsistencias</option>
                                <option value="2">Mercancía no entregada totalmente</option>
                                <option value="3">Mercancía no entregada parcialmente</option>
                                <option value="4">Servicio no prestado</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>

                    <div className='col-md-4'>
                        <button
                            onClick={() => {
                                rechazoEstado(rechazoDocumento.DocumentoId, rechazoDocumento.Razonid);
                            }}
                            className='btn bt-sm btn-danger' title='Rechazar Documento'>
                            Rechazar Documento
                        </button>
                    </div>

                </div>



            </Modal.Body>
        </Modal>



    </div>

}

export default RadianIndex;